<template>
  <div id="reg-app">
    <div class="reg-content-wrapper">
      <div class="headTips">
        <h2>注册账号</h2>
        <h5>(建议使用谷歌浏览器或360极速模式来填写该页面)</h5> <span>已有账号，<a href="/login?publicId=1464">立即登录</a></span>
      </div>
      <form id="reg_form" class="register-bar" novalidate="novalidate">
        <div class="account">
          <h2>账户信息</h2>
          <div class="borderBottom"></div>
        </div>
        <table class="account-table">
          <tbody>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">我的角色：</td>
              <td><button type="button" class="register-btn">
                  采购人
                </button> <button type="button" class="register-btn register-active" style="margin-left: 16px;">
                  供应商
                </button></td>
            </tr>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">姓名：</td>
              <td><input placeholder="填写您的真实姓名" onfocus="this.style.color='#000';this.placeholder=''"
                  onblur="this.placeholder='填写您的真实姓名'" type="text" name="truename"> <span class="startips"></span></td>
            </tr>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">用户名：</td>
              <td><input placeholder="以字母开头，4-20位字母或数字" onfocus="this.style.color='#000';this.placeholder=''"
                  onblur="this.placeholder='以字母开头，4-20位字母或数字'" type="text" name="username"> <span
                  class="startips"></span></td>
            </tr>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">密码：</td>
              <td><input type="password" placeholder="密码长度不少于6位,并且由数字和字符组成"
                  onfocus="this.style.color='#000';this.placeholder=''" onblur="this.placeholder='密码长度不少于6位,并且由数字和字符组成'"
                  id="pwd" name="pwd"> <span class="startips"></span></td>
            </tr>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">确认密码：</td>
              <td><input type="password" id="pwd_again" name="pwd_again"> <span class="startips"></span></td>
            </tr>
          </tbody>
        </table>
        <div class="enterprise">
          <h2>单位信息</h2>
          <div class="borderBottom"></div>
        </div>
        <table class="enterprise-table">
          <tbody>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">证件类型：</td>
              <td><button type="button" class="register-btn">
                  统一信用代码
                </button> <button type="button" class="register-btn register-active" style="margin-left: 16px;">
                  组织机构代码证
                </button></td>
            </tr>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">单位名称：</td>
              <td><input type="text" name="company"> <span class="startips"></span></td>
            </tr>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">组织机构代码证：</td>
              <td><input type="text" name="companyOrCertCode"> <span class="startips"></span></td>
            </tr>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">邮箱：</td>
              <td><input type="text" name="email"> <span class="startips"></span></td>
            </tr>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">手机：</td>
              <td><input type="text" name="phone"> <span class="startips"></span> <br><br> <input type="text"
                  class="tele-code"> <button type="button" class="register-btn code-button">
                  发送验证码
                </button></td>
            </tr>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">所属区域</td>
              <td>
                <el-cascader v-model="value" :options="options" @change="handleChange"></el-cascader>
                <input type="text" name="province" style="width: 0px; height: 0px; padding: 0px; position: absolute;">
                <span class="startips"></span>
              </td>
            </tr>
            <tr>
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">办公电话：</td>
              <td><input type="text" name="work_phone"> <span class="startips"></span></td>
            </tr>
            <tr style="">
              <td><img src="@/assets/images/red-start.png" style="margin-right: 10px;">会员申请所需资质：</td>
              <td>
                <div style="max-width: 350px;"><span style="font-size: 14px;">营业执照</span>
                  <div id="uploader-0">
                    <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
                      :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple
                      :limit="3" :on-exceed="handleExceed" :file-list="fileList">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                    </el-upload>

                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td><button type="button" class="register-btn register-submit">注册</button>
                <!---->
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  export default {
    name: "register",
    data() {
      return {
        value: [],
        options: [{
          value: 'zhinan',
          label: '指南',
          children: [{
            value: 'shejiyuanze',
            label: '设计原则',
            children: [{
              value: 'yizhi',
              label: '一致'
            }, {
              value: 'fankui',
              label: '反馈'
            }, {
              value: 'xiaolv',
              label: '效率'
            }, {
              value: 'kekong',
              label: '可控'
            }]
          }, {
            value: 'daohang',
            label: '导航',
            children: [{
              value: 'cexiangdaohang',
              label: '侧向导航'
            }, {
              value: 'dingbudaohang',
              label: '顶部导航'
            }]
          }]
        }, {
          value: 'zujian',
          label: '组件',
          children: [{
            value: 'basic',
            label: 'Basic',
            children: [{
              value: 'layout',
              label: 'Layout 布局'
            }, {
              value: 'color',
              label: 'Color 色彩'
            }, {
              value: 'typography',
              label: 'Typography 字体'
            }, {
              value: 'icon',
              label: 'Icon 图标'
            }, {
              value: 'button',
              label: 'Button 按钮'
            }]
          }, {
            value: 'form',
            label: 'Form',
            children: [{
              value: 'radio',
              label: 'Radio 单选框'
            }, {
              value: 'checkbox',
              label: 'Checkbox 多选框'
            }, {
              value: 'input',
              label: 'Input 输入框'
            }, {
              value: 'input-number',
              label: 'InputNumber 计数器'
            }, {
              value: 'select',
              label: 'Select 选择器'
            }, {
              value: 'cascader',
              label: 'Cascader 级联选择器'
            }, {
              value: 'switch',
              label: 'Switch 开关'
            }, {
              value: 'slider',
              label: 'Slider 滑块'
            }, {
              value: 'time-picker',
              label: 'TimePicker 时间选择器'
            }, {
              value: 'date-picker',
              label: 'DatePicker 日期选择器'
            }, {
              value: 'datetime-picker',
              label: 'DateTimePicker 日期时间选择器'
            }, {
              value: 'upload',
              label: 'Upload 上传'
            }, {
              value: 'rate',
              label: 'Rate 评分'
            }, {
              value: 'form',
              label: 'Form 表单'
            }]
          }, {
            value: 'data',
            label: 'Data',
            children: [{
              value: 'table',
              label: 'Table 表格'
            }, {
              value: 'tag',
              label: 'Tag 标签'
            }, {
              value: 'progress',
              label: 'Progress 进度条'
            }, {
              value: 'tree',
              label: 'Tree 树形控件'
            }, {
              value: 'pagination',
              label: 'Pagination 分页'
            }, {
              value: 'badge',
              label: 'Badge 标记'
            }]
          }, {
            value: 'notice',
            label: 'Notice',
            children: [{
              value: 'alert',
              label: 'Alert 警告'
            }, {
              value: 'loading',
              label: 'Loading 加载'
            }, {
              value: 'message',
              label: 'Message 消息提示'
            }, {
              value: 'message-box',
              label: 'MessageBox 弹框'
            }, {
              value: 'notification',
              label: 'Notification 通知'
            }]
          }, {
            value: 'navigation',
            label: 'Navigation',
            children: [{
              value: 'menu',
              label: 'NavMenu 导航菜单'
            }, {
              value: 'tabs',
              label: 'Tabs 标签页'
            }, {
              value: 'breadcrumb',
              label: 'Breadcrumb 面包屑'
            }, {
              value: 'dropdown',
              label: 'Dropdown 下拉菜单'
            }, {
              value: 'steps',
              label: 'Steps 步骤条'
            }]
          }, {
            value: 'others',
            label: 'Others',
            children: [{
              value: 'dialog',
              label: 'Dialog 对话框'
            }, {
              value: 'tooltip',
              label: 'Tooltip 文字提示'
            }, {
              value: 'popover',
              label: 'Popover 弹出框'
            }, {
              value: 'card',
              label: 'Card 卡片'
            }, {
              value: 'carousel',
              label: 'Carousel 走马灯'
            }, {
              value: 'collapse',
              label: 'Collapse 折叠面板'
            }]
          }]
        }, {
          value: 'ziyuan',
          label: '资源',
          children: [{
            value: 'axure',
            label: 'Axure Components'
          }, {
            value: 'sketch',
            label: 'Sketch Templates'
          }, {
            value: 'jiaohu',
            label: '组件交互文档'
          }]
        }]

      }
    },
    components: {},
    mounted() {},
    computed: {

    },
    created() {},
    methods: {
      handleChange(value) {
        console.log(value);
      }

    }
  }
</script>

<style scoped>
  .headTips {
    width: 1200px;
    margin-top: 60px;
    margin-bottom: 20px;
    position: relative;
  }

  .reg-content-wrapper {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  .headTips {
    width: 1200px;
    margin-top: 60px;
    margin-bottom: 20px;
    position: relative;
  }

  .headTips h2 {
    font-size: 28px;
    color: #333333;
    vertical-align: middle;
    display: inline-block;
    margin: 0;
  }

  .headTips h5 {
    font-size: 14px;
    color: #999;
    vertical-align: middle;
    display: inline-block;
    line-height: 28px;
    margin: 0;
  }

  .headTips span {
    font-size: 14px;
    color: #333333;
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .headTips a {
    color: #227EE9;
  }

  .register-bar {
    width: 1200px;
    padding-top: 60px;
    margin-bottom: 100px;
    background: #FFFFFF;
    font-size: 16px;
  }

  .account,
  .enterprise {
    width: 437px;
    margin: 0 auto;
  }

  .register-bar h2 {
    font-size: 24px;
    color: #333333;
    width: 96px;
    padding-bottom: 8px;
    border-bottom: 3px solid #227EE9;
    margin-bottom: 0;
  }

  .borderBottom {
    border-top: 1px solid #E0E0E0;
  }

  .account-table {
    padding-top: 35px;
    position: relative;
    left: 280px;
    font-size: 16px;
    border-collapse: inherit;
  }

  tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
  }

  tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
  }

  .register-bar table td:nth-child(1) {
    text-align: right;
    padding-right: 22px;
    width: 200px !important;
  }

  .register-bar table td {
    padding: 10px 0;
  }

  .register-btn {
    border-radius: 4px;
    border: 0;
    cursor: pointer;
    transition: all .2s;
    background: #F2F2F2;
    text-decoration: none;
    outline: none;
    height: 36px;
    width: 160px;
  }

  .register-active {
    background: #227EE9;
    color: #fff;
  }

  .register-bar input {
    background: #F2F2F2;
    border-radius: 4px;
    border: 0;
    width: 340px;
    height: 40px;
    padding-left: 15px;
    box-sizing: border-box;
    transition: all .1s;
    font-size: 16px;
  }

  .register-bar td {
    font-size: 16px;
    color: #333333;
    line-height: 19px;
    vertical-align: baseline;
  }

  .startips {
    color: #FF3300;
    line-height: 40px;
    font-size: 16px;
  }

  label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: 700;
  }

  .enterprise {
    margin-top: 40px;
  }

  .enterprise-table {
    padding-top: 35px;
    position: relative;
    left: 280px;
    border-collapse: inherit;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
